import { HashRouter, useRoutes } from 'react-router-dom';
import './App.css';
import routes from './router/routes';

const RenderRoutes = () => {
  const routeTree = useRoutes(routes)
  return routeTree
}

function App() {
  return (
    <div className="App">
      <HashRouter>
        <RenderRoutes />
      </HashRouter>
    </div>
  );
}

export default App;
